import TrackInteractionContext from '../../contexts/track-interaction-context';
import { useContext } from 'react';
function useInteractionTracker() {
    return useContext(TrackInteractionContext);
}
export default useInteractionTracker;
